import env from "./envConfig";

export const supportConfig = {
    supportContact: env.REACT_APP_SUPPORT_CONTACT,
    supportAuxiliary: env.REACT_APP_SUPPORT_AUXILIARY,
    licensingContact: env.REACT_APP_LICENSING_CONTACT
}